<!--
  No `background-color` here, deliberately.

  Paper-white behind the artwork is painted by `paintCoverWhitePlate`
  (service-ui/cover-white-plate.ts), which sizes it to the artwork alone.
  `background` on a replaced element covers the whole padding box, so a static
  `background-color: white` would also fill the letterbox bands that
  `object-fit: contain` adds to keep every tile the same size -- and those
  bands are panel, not paper. See the backdrop note in the thumbnail CSS.
-->
<img #draftCoverImage src=""
     [style.max-width.px]="width"
     [style.min-height.px]="height"
     [style.max-height.px]="height"
     style="display: block; object-fit: contain;"
     (load)="onCoverImageLoaded()"
     class="image" alt="">
